import Service from "../../services";
import { checkAndReturn } from "../../main";

const state = {};

const getters = {};

const actions = {
  index({ commit }, params) {
    return Service.CalendarActivity.index(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  show({ commit }, params) {
    return Service.CalendarActivity.show(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  save({ commit }, params) {
    return Service.CalendarActivity.save(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  create({ commit }, params) {
    return Service.CalendarActivity.create(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  edit({ commit }, params) {
    return Service.CalendarActivity.edit(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  update({ commit }, params) {
    return Service.CalendarActivity.update(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  delete({ commit }, params) {
    return Service.CalendarActivity.delete(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
